var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkewb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skewb 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M454.248 249.996L250 45.7479L45.7521 249.996L250 454.244L454.248 249.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43 43.5H230.5L43 231V43.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43 456.5V269L230.5 456.5H43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M457 456.5H269.5L457 269V456.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M457 43.5V231L269.5 43.5H457Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkewb);
export default __webpack_public_path__ + "static/media/skewb.330314dcaeb5673952158feb3b8603d9.svg";
export { ForwardRef as ReactComponent };